import React, { useState, useEffect } from "react"
import {
  Container
} from "reactstrap"
import "react-multi-carousel/lib/styles.css"

import { useParams, useLocation, useNavigate } from "react-router-dom"

import awicon from "../../assets/images/services-icon/coin.png"
import { BASE_URL } from "../../global"
//i18n
import { withTranslation } from "react-i18next"

import axios from "axios"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// @ts-ignore
import Loader from "react-spinner-loader"
import { LessonActivityOnetime } from "../../modules/lesson/activity/lesson-activity.types"

type HandledActivityTypes = LessonActivityOnetime
interface PreviewActivityOnetimeProps {
}
const PreviewActivityOnetime = (props: PreviewActivityOnetimeProps) => {
  document.title = "MyGooRoo Student App"
  const { key } = useParams()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get("type") || null
  const homework = searchParams.get("homework") || null
  const st_key = searchParams.get("st_key") || null
  const auth = searchParams.get("auth") || null


  let pk_activity_key = null
  let isHomework = null
  let IsStKey = null
  let authUser = ""

  if (key && key.length >= 16 && type && type != null && homework && homework != null && st_key && st_key != "" &&
    auth &&
    auth != "") {
    pk_activity_key = key
    isHomework = parseInt(homework) === 1
    IsStKey = st_key
    authUser = auth
  } else {
    window.history.back()
  }

  const [loader, setLoader] = useState(false)
  const [ActivityData, setActivityData] = useState<HandledActivityTypes>()

  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [location])

  const fetchData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      if (
        pk_activity_key &&
        pk_activity_key != null &&
        pk_activity_key != ""
      ) {
        setLoader(true)
        setActivityData(undefined)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post<HandledActivityTypes>(BASE_URL + "studentSession/StudentPreviewAssessmentQuestions", {
            pk_activity_key: pk_activity_key,
            subject_id: type,
            pk_student_key: IsStKey
          })
          .then(responseActivity => {
            setLoader(false)
            if (responseActivity.data.LessonActivitiesQuestions.length > 0) {

              responseActivity.data.LessonActivitiesQuestions.forEach((activityQuestion, index2) => {

                if (activityQuestion.question && activityQuestion.question.length > 0) {
                  let answerLength = activityQuestion.question[0].StudentAnsAttempts.length

                  if (isHomework) {
                    if (answerLength <= 0) {
                    }
                  } else {
                    if (answerLength <= 0) {
                    }
                  }
                } else {
                  toast.error("Question data not found", {
                    autoClose: 3000, // 3 seconds
                    onClose: () => {
                      history.back() // Navigate back in history after toast is closed
                    }
                  })
                }
              })
              setActivityData(responseActivity.data)
            } else {
              toast.error("Question data not found", {
                autoClose: 3000,
                onClose: () => {
                  history.back()
                }
              })
              setActivityData(undefined)
            }
          })
          .catch(error => {
            setLoader(false)
            if (
              (error?.response?.status === 403 || error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" || error?.response?.data?.error === "invalid algorithm" || error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              window.history.back()
            }
          })
      } else {
        setLoader(false)
        window.history.back()
      }
    } else {
      setLoader(false)
      window.history.back()
    }
  }

  return (
    <React.Fragment>
      <Loader
        show={loader}
        type="body"
      />
      <ToastContainer autoClose={3000} />
      <div className="page-wrapper">
        <div className="cs-pg-header bg-dark-blue py-4">
          <Container className="custom-wt">
            <div className="d-flex align-items-center">
              <div className="mt-0 border-right me-4" style={{ width: "20%" }}>

                <div className="text-white font-size-14 text-uppercase" onClick={() => history.back()}> {" "}
                  <span>
              <i className=" fas fa-chevron-left me-1"></i>
            </span>{" "}
                  back to tutor app
                </div>

              </div>
              <div className="d-flex align-items-center justify-content-between flex-grow-1">
                <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
                  {ActivityData && ActivityData.activity_node && ActivityData.activity_node.length > 0 && ActivityData.activity_node[0].name ? ActivityData.activity_node[0].name : null}
                </h6>
                <p className="mb-0 text-uppercase luminous-wht">
                  {" "}
                  <span
                    className="text-yellow me-1">{ActivityData && ActivityData.subject_name ? ActivityData.subject_name : null}</span> Task{" "}
                </p>
                <div className="luminous-wht font-size-16">
                  <img width={24} className="" src={awicon}
                       alt="" /> {ActivityData && ActivityData.coins_earned ? ActivityData.coins_earned : 0}/{ActivityData &&
                ActivityData.activity_node &&
                ActivityData.activity_node.length > 0 &&
                ActivityData.activity_node[0].coins
                  ? ActivityData.activity_node[0].coins
                  : 2}{" "}
                  coins
                </div>
              </div>
            </div>
          </Container>
        </div>
        {ActivityData && ActivityData.LessonActivitiesQuestions && ActivityData.LessonActivitiesQuestions.length > 0 ?

          ActivityData.LessonActivitiesQuestions.map(
            (questionActivity, activeindex) => {
              if (
                questionActivity.question &&
                questionActivity.question.length > 0
              ) {

                return questionActivity.question.map(
                  (InnerActivityData, index) => {
                    if (index === 0) {
                      return (
                        <Container className="custom-wt">
                          <div className="assessement-section summary-width-hold mt-4">
                            <div className="hw-list mt-4 pb-100">
                              <ul className="list-unstyled mb-0">
                                <li className="justify-content-between">
                                  <div className="d-flex align-items-start gap-4 justify-content-end">
                                    <div className="mb-0 d-flex align-items-center gap-2">
                                      <p
                                        className="mb-0">#{InnerActivityData.pk_onetime_activity_id ?? null}</p>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-end mt-3 mb-3">
                                  </div>
                                  <div className="video-wrapper">
                                    <h4>{InnerActivityData.name ? InnerActivityData.name : "No task"}</h4>
                                  </div>
                                  <p className="font-size-16 fw-semibold mb-2 mt-2">
                                    {ActivityData?.marked_for_homework >= 0 && (
                                      <>
                                        {ActivityData?.homework_tutor_message && ActivityData.marked_for_homework == 1 ? (
                                          <>
                                            <b>Tutor message:</b> {ActivityData.homework_tutor_message}
                                          </>
                                        ) : ActivityData?.lesson_tutor_message ? (
                                          <>
                                            <b>Tutor message:</b> {ActivityData.lesson_tutor_message}
                                          </>
                                        ) : null}
                                      </>
                                    )}
                                  </p>
                                  <p className="font-size-16 fw-semibold mb-4 mt-2">
                                    {ActivityData?.tutor_comments && (
                                      <>
                                        <b>Tutor comments:</b>{" "}
                                        {ActivityData.tutor_comments}
                                      </>
                                    )}
                                  </p>
                                </li>
                              </ul>
                            </div>

                          </div>
                        </Container>
                      )
                    }
                  })
              }
            })

          : null
        }


      </div>
    </React.Fragment>
  )
}


export default withTranslation()(PreviewActivityOnetime)
